import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { NotificationDeliveryTarget, NotificationDeliveryType, NotificationDeliveryTypeMap } from 'constants/notice';
import { NotificationListItemFragment } from 'views/utils/graphql/graphql';
import { PagePath } from 'constants/pagePath';
import { LoadingContainer } from 'views/mutual/loading';
import { ListItem } from 'views/mutual/list';
import { NoticeDetailLocationState } from 'views/pages/noticeDetail';

type NotificationListItemProps = {
  itemIndex: number;
  notification: Omit<NotificationListItemFragment, '__typename'>;
  isDetail?: boolean;
  previousPage: string;
};

export const NotificationListItem: React.FC<NotificationListItemProps> = ({
  itemIndex,
  notification,
  isDetail,
  previousPage,
}: NotificationListItemProps) => {
  return (
    <ListItem itemIndex={itemIndex} className="notificationList">
      <div className="notificationList_firstRow">
        {notification.DeliveryTarget === NotificationDeliveryTarget.Personal && (
          <div className="noticeConfirmed">{notification.Confirmed ? '確認済' : '未確認'}</div>
        )}
        <div className="notificationList_date">{notification.PublishStartDate}</div>
        <div className="notificationList_status">
          {NotificationDeliveryTypeMap[notification.DeliveryType as NotificationDeliveryType].name}
        </div>
      </div>
      {isDetail ? (
        <div className="notificationList_title">{notification.Title}</div>
      ) : (
        <NavLink
          to={`${PagePath.NoticeDetail}${notification.ID}/`}
          state={{ previousPage } as NoticeDetailLocationState}
          className="notificationList_title"
        >
          {notification.Title}
        </NavLink>
      )}
    </ListItem>
  );
};

export type NotificationListProps = {
  isLoading: boolean;
  items: Array<NotificationListItemFragment | null>;
  previousPage: string;
};
export const NotificationList = ({ isLoading, items, previousPage }: NotificationListProps) => {
  return (
    <div className="notificationListWrapper">
      <LoadingContainer isLoading={isLoading}>
        {items
          ?.filter((x) => (x ? true : false))
          .map((item, index) => (
            <NotificationListItem key={item!.ID} itemIndex={index} notification={item!} previousPage={previousPage} />
          ))}
      </LoadingContainer>
    </div>
  );
};
